import { useEffect } from "react";

// Animation using WOW.js
export const useAnimation = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const WOW = require("wowjs");
      new WOW.WOW().init();
    }
  }, []);
};

// Progress Bar Animation
export const useProgressBar = () => {
  useEffect(() => {
    const progressBarHandler = () => {
      const progressBarLists = document.querySelectorAll(
        ".progress-bar-wrapper"
      );
      const triggerBottom = (window.innerHeight / 5) * 5;

      progressBarLists.forEach((element) => {
        let percentage = element.getAttribute("data-percentage"),
          progressLineWrap =
            element.getElementsByClassName("progress-line-wrap")[0],
          progressLine = element.getElementsByClassName("progress-line")[0],
          progressLineWidth = `${percentage}%`,
          progressLineBg = element.getAttribute("data-line-bg"),
          progressLineColor = element.getAttribute("data-line-color");

        progressLineWrap.style.backgroundColor = progressLineBg;
        progressLine.style.backgroundColor = progressLineColor;

        const progressTop = element.getBoundingClientRect().top;
        if (progressTop < triggerBottom) {
          progressLine.style.width = progressLineWidth;
        } else {
          progressLine.style.width = 0;
        }
      });
    };

    window.addEventListener("scroll", progressBarHandler);
    return () => window.removeEventListener("scroll", progressBarHandler);
  }, []);
};

// Pagination
export const pagination = (listClass, sort, active) => {
  const list = document.querySelectorAll(listClass);
  list.forEach((element, index) => {
    element.classList.toggle(
      "d-none",
      !(active === 1
        ? index < sort
        : index >= (active - 1) * sort && index < active * sort)
    );
  });
};

// Get Pagination
export const getPagination = (totalNumber, sort) => {
  return Array.from(
    { length: Math.ceil(totalNumber / sort) },
    (_, idx) => idx + 1
  );
};

// Custom Select (NiceSelect)
export const useNiceSelect = () => {
  useEffect(() => {
    const selectElements = document.querySelectorAll("select");
    selectElements.forEach((select) => {
      const options = Array.from(select.options);
      select.style.display = "none";
      const niceSelect = document.createElement("div");
      niceSelect.className = "nice-select wide";
      select.parentNode.insertBefore(niceSelect, select.nextSibling);

      const span = document.createElement("span");
      span.className = "current";
      niceSelect.appendChild(span);

      const ul = document.createElement("ul");
      ul.className = "list";
      niceSelect.appendChild(ul);

      options.forEach((opt) => {
        const li = document.createElement("li");
        li.className = "option";
        li.textContent = opt.text;
        ul.appendChild(li);

        li.addEventListener("click", () => {
          if (!opt.disabled) {
            span.textContent = opt.text;
          }
        });

        if (opt.selected) {
          span.textContent = opt.text;
          li.classList.add("focus");
        }
      });

      niceSelect.addEventListener("click", () => {
        niceSelect.classList.toggle("open");
      });

      document.addEventListener("click", (e) => {
        if (!niceSelect.contains(e.target)) {
          niceSelect.classList.remove("open");
        }
      });
    });
  }, []);
};

// Sticky Navbar
export const useStickyNav = () => {
  useEffect(() => {
    const handleScroll = () => {
      const headers = document.querySelectorAll("header");
      headers.forEach((header) => {
        header.classList.toggle("sticky-on", window.scrollY > 60);
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};

// Scroll to Top Button
export const useScrollTop = () => {
  useEffect(() => {
    const scrollTopBtn = document.getElementById("scroll-top");
    const handleScroll = () => {
      scrollTopBtn.classList.toggle("active", window.scrollY > 110);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};
